import React from 'react';
import PropTypes from 'prop-types';

const SearchIcon = ({className}) => (
  <svg
    aria-hidden="true"
    className={className}
    fill="none"
    stroke="currentColor"
    strokeLinecap="round"
    strokeWidth="1.5"
    viewBox="0 0 16 16"
  >
    <circle cx="7" cy="7" r="5" />
    <path d="M10.75 10.75L14 14" />
  </svg>
);

SearchIcon.propTypes = {
  className: PropTypes.string,
};

export default SearchIcon;



// WEBPACK FOOTER //
// ./src/components/search/SearchIcon.js